export const REFRESH_BUFFER_SEC = 60;
